<template>
  <v-container fluid style="padding:0">
    <v-combobox
        class="demofields"
        dense
        outlined
        v-model="valout"
        :items="dxitems"
        :loading="isLoading"
        :search-input.sync="dxsearch"
        hide-no-data
        hide-selected
        item-text="description"
        :label="(qaVal && qaVal.code ? 'Code: ' + qaVal.code + (qaVal && qaVal.code == valout.code ? ' - ✓' : ' - ✗' ) : 'Code')"
        return-object
        :disabled="ro"
    ></v-combobox>
  </v-container>
</template>

<script>
// import { mapGetters } from "vuex";

export default{
  name: 'DXAPI',
    props: {
        value:{
            type:Object,
            required:true
        },
        ro:{
            type:Boolean,
            required:true
        },
        qaVal:{type:Object},
        // ind:{type:Number},
        // reqInds:{type:Array}
    },
    data() {
        return {
            isLoading:false,
            dxsearch:"",
            entries:[],
            entriesCustom:[],
            count:0,
            valout:null,
            isEditing:false,
        };
    },
    computed:{
        dxitems(){
        return this.entries.map(entry => {
            const description = entry.code + " - " + (entry.name.length > this.descriptionLimit
            ? entry.name.slice(0, this.descriptionLimit) + '...'
            : entry.name)
            return Object.assign({}, entry, { description });
        })
        },
    },
    watch:{
        dxsearch(val){
            // Items have already been loaded
            if (val && val.length > 0){
                if (val && val.length > 15) return
                // Items have already been requested
                if (this.isLoading) return
                this.isLoading= true
                // Lazily load input items
                fetch('https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms='+val)
                    .then(res => res.json())
                    .then(res => {
                        let resarr = res[3],rlen=resarr.length,entries=[];
                        for(let r=0; r<rlen; r++){
                            entries.push({
                                name: resarr[r][1],
                                code: resarr[r][0],
                            })
                        }
                        this.count = rlen
                        this.entries = [...this.entriesCustom,...entries].sort((a, b) => (a.code > b.code) ? 1 : -1);
                    })
                    .catch(err => {
                         console.log(err)
                    })
                    .finally(() => (this.isLoading= false))
            }
        },
        valout(){
            if(this.valout){
                let out;
                if(this.valout.code){
                    out = this.valout;
                }else if(typeof this.valout !== 'object' && this.valout !== null){
                //else if(this.valout){
                    let code = this.valout.toString().toUpperCase().replace(/\s+/g, '');
                    out = {code: code, name:"USER ADDED",description: code + " - USER ADDED"};
                }else{
                    //// console.log(this.valout);
                    out = {code:"",name:"",description:""}
                }
                this.$emit('input',out);
            }
        }
    },
    mounted: function(){
        //// console.log(this.$store.getters.dxs[0].code);
        this.entriesCustom = this.$store.getters.dxs;
        this.valout = this.value;
    },
    // beforeMount: function() {
    //     // console.log(JSON.stringify(this.value));
    //     if(this.value.description){
    //         this.isEditing = false;
    //         this.valout = this.value;
    //         //this.dxsearch = this.value.description;
    //     }else{
    //         this.valout = {code:this.value,description:this.value};
    //         this.isEditing = true;
    //     }
    // },
    methods: {
        
    }
  };
</script>

<style>
</style>